import { create } from "zustand";

/** Lets any page (contacts, history) ask the softphone to dial a number. */
export const useDialer = create<{ request: { number: string; nonce: number } | null; dial: (number: string) => void; clear: () => void }>((set) => ({
  request: null,
  dial: (number) => set({ request: { number, nonce: Date.now() } }),
  clear: () => set({ request: null }),
}));
